<template>
  <v-container>
    <v-select
      v-model="model"
      :items="categories"
      item-value="id"
      item-text="name"
      :loading="loading"
      :required="mandatory"
      :rules="checkRules"
      :error="showError"
      clearable
    />
  </v-container>
</template>

<script>
export default {
  name: 'AppointmentCategoryDropdown',
  props: {
    value: {
      type: String
    },
    mandatory: {
      type:Boolean,
      defualt: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    checkRules(){
      if(this.mandatory) {
      return (this.model) ? [] : [this.$_t('Required')]
      } else {
        return []
      }
    },
    showError(){
      if(this.mandatory) {
        return (this.model) ? false : true

      } else {
        return false
      }


    }
  },
  data () {
    return {
      categories: [],
      loading: false
    }
  },
  mounted () {
    this.getCategories()
  },
  methods: {
    getCategories () {
      this.loading = true
      this.$_rest.get(`/practitioners/${ this.$store.getters['app/currentUserId'] }/appointment-categories`, undefined, response => {
        this.loading = false
        this.categories = response.data
      }, error => {
        this.loading = false
        this.$_notify.error(error)
      }, {
        prefixRoutesWithOrganizationId: true
      })
    }
  }
}
</script>

<style scoped>

</style>
